const getters = {
  userInfo: state => state.user.userInfo,
  menu: state => state.system.menu,
  productInfo: state => state.system.productInfo,
  config: state => state.system.config,
  // 字典数据和对象
  enumMap: state => state.enum.enumMap,
  enumData: state => state.enum.enumData,
  allProducts: state => state.product.allProducts,
  apiLoading: state => state.system.apiLoading,
  pageLoading: state => state.system.pageLoading,
}
export default getters
